module.exports = __webpack_public_path__ + "img/NL.71a24286.svg";